import type { IThresherAdView, IToolsAdView, ITractorAdView } from "@finn-no/adview-provider-frontend-types";
import type { AgricultureAd } from "@mobility-item-page/types";
import { KeyInfo } from "../../key-info/KeyInfo.tsx";
import { Effect } from "../Effect.tsx";
import { Fuel } from "../Fuel.tsx";
import { Make } from "../Make.tsx";
import { Model } from "../Model.tsx";
import { ModelYear } from "../ModelYear.tsx";
import { SpecificationsArea } from "../SpecificationsArea.tsx";
import { VolumeLitre } from "../VolumeLitre.tsx";
import { Weight } from "../Weight.tsx";
import { Category } from "./Category.tsx";
import { HoursUsed } from "./HoursUsed.tsx";
import { Tyres } from "./Tyres.tsx";

export const AgricultureSpecifications = ({ ad }: { ad: AgricultureAd }) => {
  const specifications = () => {
    switch (ad.adViewType) {
      case "agriculture-tractor":
        return <AgricultureTractorSpecifications ad={ad} />;
      case "agriculture-thresher":
        return <AgricultureThresherSpecifications ad={ad} />;
      case "agriculture-tools":
        return <AgricultureToolsSpecifications ad={ad} />;
      default:
        return null;
    }
  };

  const content = specifications();

  if (!content) {
    return null;
  }

  return (
    <SpecificationsArea>
      <KeyInfo>{content}</KeyInfo>
    </SpecificationsArea>
  );
};

const AgricultureTractorSpecifications = ({ ad }: { ad: ITractorAdView }) => {
  return (
    <>
      {/*General information*/}
      <Make make={ad.make} />
      <Model model={ad.model} />
      <ModelYear year={ad.year} />
      <HoursUsed hoursUsed={ad.hours_used} />

      {/*Product properties*/}
      <Fuel fuel={ad.engine?.fuel} />
      <Effect effect={ad.engine?.effect} />
      <VolumeLitre volume={ad.engine?.volume} />
      <Weight weight={ad.weight} />
      <Tyres tyres={ad.tyres} />

      {/*Appearance*/}

      {/*Registration, warranty, owners, etc*/}
    </>
  );
};

const AgricultureThresherSpecifications = ({ ad }: { ad: IThresherAdView }) => {
  return (
    <>
      {/*General information*/}
      <Make make={ad.make} />
      <Model model={ad.model} />
      <ModelYear year={ad.year} />
      <HoursUsed hoursUsed={ad.hours_used} />

      {/*Product properties*/}
      <Fuel fuel={ad.engine?.fuel} />
      <Effect effect={ad.engine?.effect} />
      <VolumeLitre volume={ad.engine?.volume} />
      <Weight weight={ad.weight} />

      {/*Appearance*/}

      {/*Registration, warranty, owners, etc*/}
    </>
  );
};

const AgricultureToolsSpecifications = ({ ad }: { ad: IToolsAdView }) => {
  return (
    <>
      {/*General information*/}
      <Make make={ad.make} />
      <Model model={ad.model} />
      <Category category={ad.category} />
      <ModelYear year={ad.year} />

      {/*Product properties*/}
      <Weight weight={ad.weight} />

      {/*Appearance*/}

      {/*Registration, warranty, owners, etc*/}
    </>
  );
};
